import React from 'react'
import { navigate } from 'gatsby'
import { styled } from '@mui/material/styles'

import { Auth0Provider } from './src/services/auth'

export const wrapRootElement = ({ element }) => {
  const onRedirectCallback = (appState) => {
    navigate(appState && appState.targetUrl ? appState.targetUrl : isBrowser() ? window.location.pathname : '/')
  }

  const StyledWrapper = styled('div')(() => ({
    '#gatsby-focus-wrapper': {
      minHeight: '100vh',
      position: 'relative',
    },
  }))

  return (
    <StyledWrapper>
      <Auth0Provider
        domain={process.env.GATSBY_AUTH0_DOMAIN}
        client_id={process.env.GATSBY_AUTH0_CLIENTID}
        audience={process.env.GATSBY_AUTH0_AUDIENCE}
        scope="openid profile email read:current_user update:current_user_metadata"
        redirect_uri={process.env.GATSBY_AUTH0_CALLBACK}
        cacheLocation="localstorage"
        onRedirectCallback={onRedirectCallback}
        useRefreshTokens={true}
      >
        {element}
      </Auth0Provider>
    </StyledWrapper>
  )
}
